var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-red-200 border-2 border-red-300 mt-10 rounded-lg text-red-800 p-4 text-center"},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }